import { MoveDirection, OutMode } from '@tsparticles/engine';

export const subtleParticles = {
  fullScreen: false,
  background: { color: { value: 'transparent' } },
  fpsLimit: 60,
  interactivity: { events: {} }, // No interactivity
  particles: {
    color: { value: '#ffffff' },
    links: {
      enable: true,
      distance: 80,
      color: '#ffffff',
      opacity: 0.07,
      width: 0.5,
    },
    move: {
      direction: MoveDirection.none,
      enable: true,
      outModes: { default: OutMode.destroy },
      random: false,
      speed: 0.15,
      straight: false,
    },
    number: {
      density: { enable: true, value_area: 200 },
      value: 72,
    },
    opacity: {
      value: 0.18,
      random: true,
      animation: {
        enable: true,
        speed: 0.5,
        minimumValue: 0.08,
        sync: false,
      },
    },
    shape: { type: 'circle' },
    size: {
      value: { min: 0.5, max: 4.4 },
      random: true,
      animation: {
        enable: true,
        speed: 0.5,
        minimumValue: 0.1,
        sync: false,
      },
    },
    twinkle: {
      particles: {
        enable: true,
        color: '#ffffff',
        frequency: 0.01,
        opacity: 1,
      },
    },
  },
  detectRetina: true,
};

export const subtleParticlesMobile = {
  ...subtleParticles,
  particles: {
    ...subtleParticles.particles,
    number: {
      ...subtleParticles.particles?.number,
      value_area: 3000,
      value: 180,
    },
  },
};

export const interactiveParticles = {
  fullScreen: false,
  background: { color: { value: 'transparent' } },
  fpsLimit: 120,
  interactivity: {
    events: {
      onHover: { enable: true, mode: 'connect' },
    },
    modes: {
      connect: {
        distance: 140,
        radius: 120,
        links: { opacity: 0.2, color: '#8468FF' },
      },
    },
  },
  particles: {
    color: { value: '#ffffff' },
    links: {
      enable: true,
      distance: 120,
      color: '#ffffff',
      opacity: 0.12,
      width: 1,
    },
    move: {
      direction: MoveDirection.none,
      enable: true,
      outModes: { default: OutMode.destroy },
      random: true,
      speed: 0.5,
      straight: true,
    },
    number: {
      density: { enable: true, value_area: 600 },
      value: 160,
    },
    opacity: {
      value: 0.3,
      random: true,
      animation: {
        enable: true,
        speed: 1,
        minimumValue: 0.1,
        sync: false,
      },
    },
    shape: { type: 'circle' },
    size: {
      value: { min: 0.5, max: 3.5 },
      random: true,
      animation: {
        enable: true,
        speed: 1,
        minimumValue: 0.1,
        sync: false,
      },
    },
    twinkle: {
      particles: {
        enable: true,
        color: '#ffffff',
        frequency: 0.05,
        opacity: 1,
      },
    },
  },
  detectRetina: true,
};

export const interactiveParticlesMobile = {
  ...interactiveParticles,
  particles: {
    ...interactiveParticles.particles,
    number: {
      ...interactiveParticles.particles?.number,
      value: 200,
    },
  },
};

export const starParticles = {
  fullScreen: true,
  background: { color: { value: 'transparent' } },
  fpsLimit: 120,
  interactivity: {
    events: {
      onHover: {
        enable: true,
        mode: 'bubble',
        parallax: {
          enable: false,
          force: 2,
          smooth: 10,
        },
      },
      resize: {
        delay: 0.5,
        enable: true,
      },
    },
    modes: {
      bubble: {
        distance: 250,
        duration: 2,
        mix: false,
        opacity: 0,
        size: 0,
      },
      repulse: {
        distance: 400,
        duration: 0.4,
        factor: 100,
        speed: 1,
        maxSpeed: 50,
        easing: 'ease-out-quad',
      },
    },
  },
  particles: {
    color: { value: '#ffffff', opacity: 0.4 },
    links: {
      enable: false,
    },
    move: {
      direction: MoveDirection.none,
      enable: true,
      outModes: { default: OutMode.out },
      random: false,
      speed: { min: 0.1, max: 1 },
      straight: false,
    },
    number: {
      value: 50,
    },
    opacity: {
      value: { min: 0.1, max: 1 },
      animation: {
        enable: true,
        speed: 1,
        minimumValue: 0.1,
        sync: false,
      },
    },
    shape: { type: 'circle' },
    size: {
      value: { min: 1, max: 3 },
      random: true,
      animation: {
        enable: false,
        speed: 5,
        minimumValue: 0.1,
        sync: false,
      },
    },
    twinkle: {
      particles: {
        enable: true,
        color: '#ffffff',
        frequency: 0.05,
        opacity: 0.6,
      },
    },
  },
  detectRetina: true,
};

export const starParticlesMobile = {
  ...starParticles,
  particles: {
    ...starParticles.particles,
    number: {
      ...starParticles.particles?.number,
      value: 200,
    },
  },
};
